
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rate",
      function () {
        return require("private-next-pages/rate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rate"])
      });
    }
  